import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.403 5.348a3 3 0 0 1 0 5.304 2.999 2.999 0 0 1-3.751 3.751 3 3 0 0 1-5.304 0 3 3 0 0 1-3.751-3.75 3 3 0 0 1 0-5.305 3 3 0 0 1 3.75-3.751 3 3 0 0 1 5.305 0 3 3 0 0 1 3.751 3.75Zm-2.903.456a.5.5 0 0 0-.794-.608L7.462 9.598l-2.21-2.192a.5.5 0 1 0-.704.71l2.613 2.592a.5.5 0 0 0 .749-.05l3.59-4.854Z",
  fill: "#4D9FE3"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }